import { useMemo } from "react";
import { getItem } from "tools/localStorage";
import { ExpandedOrder } from "ts/api/order";
import { FullProduct, LocalStorageProduct } from "ts/api/product";
import { useCartLocalStorageKey } from "view/apps/Exhibitor/pages/Cart/shared";
import mapStorageProductsToCartProducts from "view/apps/Exhibitor/pages/Cart/helpers/mapStorageProductsToCartProducts";

const useOrderProducts = ({
  showProducts,
  orderProducts,
  order,
}: {
  showProducts?: FullProduct[];
  orderProducts?: FullProduct[];
  order?: ExpandedOrder;
}): FullProduct[] => {
  const localStorageCartKey = useCartLocalStorageKey();
  const products = useMemo((): FullProduct[] => {
    if (!showProducts) {
      return [];
    }
    if (order && orderProducts) {
      return orderProducts.map<FullProduct>((p) => ({
        ...p,
        discountAmount: 0,
        discountCodes: [],
      }));
    }
    const storageProductsItems = getItem<LocalStorageProduct[]>(
      localStorageCartKey
    );

    return mapStorageProductsToCartProducts(storageProductsItems, showProducts);
  }, [showProducts, order, orderProducts]);
  return products;
};

export default useOrderProducts;
